export default __webpack_public_path__ + "static/media/background.53d87caa.png";